import clsx from "clsx";
import styles from "./index.module.scss";

export default function Checkbox({
  onChange = () => {},
  checked,
  label,
  test = "",
  isOld = false,
}) {
  return (
    <div
      className={styles.Checkbox}
      onClick={onChange}
      data-test={test}
      aria-label={label}
    >
      <span
        className={clsx(
          isOld ? styles.BoxOld : styles.Box,
          checked && (isOld ? styles.BoxOldChecked : styles.BoxChecked),
        )}
      />
      {label && <span>{label}</span>}
    </div>
  );
}
